(function () {
    'use strict';

    angular.module("imApp").factory("batchDeliverySelectPurchHeadService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 820,
                    parameters: parms || {}
                });
            },
            listPurchaseOrders: function (parms) {
                return $ihttp.post({
                    method: 285,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
